import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useSwiper } from "swiper/react";
import { dsnCN } from "../../hooks/helper";

import { useAnalytics } from "reactfire";
import { logEvent } from "firebase/analytics";

function ControlNav({ className, ...restProps }) {
  const swiper = useSwiper();
  const analytics = useAnalytics;

  return (
    <div className={dsnCN("control-nav", className)} {...restProps}>
      <div
        className="prev-container"
        onClick={() => {
          swiper.slidePrev();
          logEvent(analytics, "slide_Previous");
        }}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
      </div>

      <div
        className="next-container"
        onClick={() => {
          swiper.slideNext();
          logEvent(analytics, "slide_Next");
        }}
      >
        <FontAwesomeIcon icon={faAngleRight} />
      </div>
    </div>
  );
}

export default ControlNav;
